//=require scripts/helpers.js
//=require scripts/config.js
//=require scripts/scripts.js
//=require scripts/contacts.js
//=require scripts/scroll-to-anchor.js
//=require scripts/header.js
//=require scripts/form-validate.js
//=require scripts/header-nav-link.js
//=require scripts/reviews-video.js
//=require scripts/service-prices-table.js
//=require scripts/custom-scroll.js
//=require scripts/blog.js
//=require scripts/footer.js
//=require scripts/banners.js
//=require scripts/form-kuzov.js
//=require scripts/init-gallery-slider.js

